import React, { useState } from "react";
import Alert from "utils/Alert";
import copyImage from "../assets/images/copy (1).svg";

const bidObj = {
  fiverr: `Hello, How are you? I have read your requirements, you are looking for ....its project... I have been doing effective Web-Development for US businesses since 2017. My profile here on FIVERR speaks volumes about my service and commitment to my clients. .......my words for project....... Just check some samples related to your work: ......another links....... . You can watch my diversified portfolio at (https://smashcode.dev/) I have a question that ................ Looking forward to your response and doing business with you. Thanks`,
  upwork: `Hello, How are you? I have read your requirements, you are looking for ....its project... I have been doing effective Web-Development for US businesses since 2017. My profile here on UPWORK speaks volumes about my service and commitment to my clients. .......my words for project....... Just check some samples related to your work: ......another links....... . You can watch my diversified portfolio at ( https://smashcode.dev/) I have a question that ................ Looking forward to your response and doing business with you. Thanks`,
};

const PlatformBids = () => {
  const [alert, setAlert] = useState({ open: false, msg: "", type: "" });

  const copyText = (text) => {
    navigator.clipboard
      .writeText(text)
      .then((res) => {
        setAlert({
          open: true,
          msg: "Text Copied successfully.",
          type: "success",
        });
      })
      .catch((err) => {
        setAlert({ open: true, msg: "Something went wrong!", type: "error" });
      });
  };

  return (
    <div>
      <div>
        <br />
        <h2>Fiverr Bid</h2>
        <br />
        <div>
          <div className="paraBox">
            <button className="copyBtn" onClick={() => copyText(bidObj.fiverr)}>
              <img src={copyImage} alt="copy" />
            </button>
            <p>{bidObj.fiverr}</p>
          </div>
        </div>
        <br />
        <h2>Upwork Bid</h2>
        <br />
        <div>
          <div className="paraBox">
            <button className="copyBtn" onClick={() => copyText(bidObj.upwork)}>
              <img src={copyImage} alt="copy" />
            </button>
            <p>{bidObj.upwork}</p>
          </div>
        </div>
      </div>
      <Alert data={alert} setAlert={setAlert} />
    </div>
  );
};

export default PlatformBids;
